import ResourceFilterHoc from './ResourceFilterHoc';
import { useState } from 'react';
import SharedDatePicker from 'src/components/DatePicker';
import SearchableDropdown from 'src/components/SearchableDropdown';
import { Flex, Switch, Typography } from 'antd';
import EditProjectModal from './EditProjectModal';
import AntDButton from 'src/components/Button';
import en from 'src/messages/en.json';

const TimesheetFilters = ({
  weekDate,
  onWeekChange,
  onWorkWeekChange,
  onReporteeChange,
  weekType,
  teamTime,
  onToggleAutoFill,
  submissionStatus,
  autoFillVal,
  autoFillToggleStatus,
}) => {
  const onUserChange = (userEmail) => {
    onReporteeChange(userEmail);
  };
  const weekStyle = {
    width: '9.375rem',
  };
  const weekOptions = [
    { label: 'Week', value: 'week' },
    { label: 'Work Week', value: 'work_week' },
  ];

  const [OpenModal, setOpenModal] = useState(false);

  return (
    <Flex
      align="center"
      gap={'small'}
      justify="space-between"
      style={{ padding: '0 0 1rem' }}
    >
      <Flex align="center" gap={'middle'}>
        <SharedDatePicker
          startDate={weekDate}
          onChange={onWeekChange}
          mode="week"
          isWorkWeek={weekType === 'work_week'}
          showWeek={false}
          allowClear={false}
        />
        {!teamTime && (
          <Flex align="center" gap={'small'}>
            <Switch
              id="custom-switch"
              checked={autoFillVal}
              onChange={onToggleAutoFill}
              disabled={submissionStatus || autoFillToggleStatus}
            />
            <Typography.Text strong>Auto Fill</Typography.Text>
          </Flex>
        )}
      </Flex>

      <Flex gap={'middle'} align="center">
        {teamTime ?? (
          <AntDButton
            type="primary"
            onClick={() => setOpenModal(true)}
            statusOnComplete="Edit Projects/Initiatives"
            htmlType="button"
          />
        )}

        <SearchableDropdown
          onChange={onWorkWeekChange}
          style={weekStyle}
          options={weekOptions}
          placeholder={en.Timesheet.Placeholder.selectWeekType}
          selected={[weekType]}
          showSearch={false}
          allowClear={false}
          isWeek={true}
          showArrow={true}
        />
        <ResourceFilterHoc teamTime={teamTime} onUserChange={onUserChange} />
        <EditProjectModal
          show={OpenModal}
          onHide={() => setOpenModal(false)}
          weekDate={weekDate}
        />
      </Flex>
    </Flex>
  );
};

export { TimesheetFilters };
